// src/pages/Contact.jsx
import React, { useState } from 'react';
import '../styles/contact.css';
import { Mail, Phone, MapPin, Clock, Send } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitStatus, setSubmitStatus] = useState({
    message: '',
    type: '' // 'success' or 'error'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your form submission logic here
    setSubmitStatus({
      message: 'Thank you for your message! We will get back to you soon.',
      type: 'success'
    });
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="hero-section text-white py-5">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold mb-4">Contact Us</h1>
              <p className="lead mb-0">Get in touch with our team for any inquiries or support</p>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Info Cards */}
      <div className="container contact-cards-section mt-4">
        <div className="row g-4">
          <div className="col-md-4">
            <div className="contact-card">
              <div className="card-icon">
                <Phone size={24} />
              </div>
              <h4>Call Us</h4>
              <p>Mon-Fri from 8am to 5pm</p>
              <a href="tel:+1234567890" className="contact-link">+1 (234) 567-890</a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="contact-card">
              <div className="card-icon">
                <Mail size={24} />
              </div>
              <h4>Email Us</h4>
              <p>We'll respond within 24 hours</p>
              <a href="mailto:support@muslimsrestro.com" className="contact-link">
                support@muslimsrestro.com
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="contact-card">
              <div className="card-icon">
                <MapPin size={24} />
              </div>
              <h4>Visit Us</h4>
              <p>Come say hello at our office</p>
              <span className="contact-link">123 Halal Street, NY 10001</span>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-6">
            <div className="contact-form-container">
              <h2 className="mb-4">Send us a Message</h2>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.name}
                        onChange={(e) => setFormData({...formData, name: e.target.value})}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Phone</label>
                      <input
                        type="tel"
                        className="form-control"
                        value={formData.phone}
                        onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Subject</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.subject}
                        onChange={(e) => setFormData({...formData, subject: e.target.value})}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="form-label">Message</label>
                      <textarea
                        className="form-control"
                        rows="5"
                        value={formData.message}
                        onChange={(e) => setFormData({...formData, message: e.target.value})}
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-12">
                    {submitStatus.message && (
                      <div className={`alert alert-${submitStatus.type}`}>
                        {submitStatus.message}
                      </div>
                    )}
                    <button type="submit" className="btn btn-primary">
                      <Send size={18} className="me-2" />
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="contact-info">
              <h2 className="mb-4">Office Hours</h2>
              <div className="office-hours">
                <div className="hours-item">
                  <Clock size={20} />
                  <div>
                    <h5>Monday - Friday</h5>
                    <p>9:00 AM - 6:00 PM</p>
                  </div>
                </div>
                <div className="hours-item">
                  <Clock size={20} />
                  <div>
                    <h5>Saturday</h5>
                    <p>10:00 AM - 4:00 PM</p>
                  </div>
                </div>
                <div className="hours-item">
                  <Clock size={20} />
                  <div>
                    <h5>Sunday</h5>
                    <p>Closed</p>
                  </div>
                </div>
              </div>

              <h2 className="mb-4 mt-5">FAQ</h2>
              <div className="faq-section">
                <div className="faq-item">
                  <h5>How do I list my restaurant?</h5>
                  <p>Visit our restaurant partner page to register your establishment.</p>
                </div>
                <div className="faq-item">
                  <h5>How is Halal verification done?</h5>
                  <p>We have a thorough verification process including certificate checks and site visits.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;